// Desktop inactivity policy.
//
// A desktop terminal's session is valid for up to 14 days so it can keep
// selling through a real connectivity outage. That window is a tolerance for
// being offline — NOT an inactivity policy. While the terminal actually has
// connectivity, an unattended till signs itself out after this much idle
// time, so a walk-up at 2am doesn't find a logged-in POS.
export const DESKTOP_ONLINE_IDLE_MIN = 480; // 8 hours — one shift

const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'touchstart', 'wheel'];
const CHECK_INTERVAL_MS = 60 * 1000;

// Returns a cleanup function.
export const startDesktopIdleWatch = (onIdle) => {
  let lastActivity = Date.now();
  const bump = () => { lastActivity = Date.now(); };
  ACTIVITY_EVENTS.forEach((evt) => window.addEventListener(evt, bump, { passive: true }));

  const timer = setInterval(() => {
    if (!navigator.onLine) {
      // Offline: the server-side 14-day window is the only thing that
      // applies. Keep the idle clock reset so a long outage doesn't sign the
      // cashier out the moment connectivity returns.
      bump();
      return;
    }
    if (Date.now() - lastActivity > DESKTOP_ONLINE_IDLE_MIN * 60 * 1000) onIdle();
  }, CHECK_INTERVAL_MS);

  return () => {
    clearInterval(timer);
    ACTIVITY_EVENTS.forEach((evt) => window.removeEventListener(evt, bump));
  };
};
